import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom, lastValueFrom, Subject } from 'rxjs';
import { RewardData, ProductReward, Advertiser, CampaignsAdvertiserAdminApiClient, PunchCardSchema, PunchCardStep, PunchCardStrategyType, CampaignsProductAdminApiClient, ConsumptionValidationToolEnum, FilterValidationToolOperatorEnum, IProduct, CalculationBasedType, CampaignTargetUser } from 'src/app/api/api-campaigns.service.generated';
import { ProductInfo, RewardsProductApiClient } from 'src/app/api/api-rewards.service.generated';

@Injectable({
  providedIn: 'root'
})
export class PunchCardCampaignService {
  private rewardProductsApi = inject(RewardsProductApiClient);
  private advertiserApi = inject(CampaignsAdvertiserAdminApiClient);
  private campaignsProductClient = inject(CampaignsProductAdminApiClient);


  advertiser: Advertiser;
  advertiserId: any;
  rewardProductsOptions: RewardData[] = [];
  isLoading = false;
  schemList: PunchCardSchema[];
  stepList: PunchCardStep[];
  private _productList: IProduct[]=[];
  get productList(): IProduct[]{
    return this._productList;
  }
  set productList(value: any){
    this._productList = value;
    this.onProductListFinished.next(value);
  }
  captureToolType: string = '';
  viewMode: 'target-role' | 'receipt' | 'scheme' | 'flow' | 'locations' | 'consumer-referral' | 'staff-referral' | 'media' | 'banner' | 'json' | '' = '';
  onFlowChange: BehaviorSubject<any> = new BehaviorSubject(undefined);
  onStrategyChange: BehaviorSubject<PunchCardStrategyType> = new BehaviorSubject(undefined);
  private _strategyType: PunchCardStrategyType;
  get strategyType(): PunchCardStrategyType{
    return this._strategyType;
  }
  set strategyType(value:PunchCardStrategyType){
      this._strategyType = value;
      this.onStrategyChange.next(value);
  }

  allowFlow: boolean = false;

  strategyTypes = PunchCardStrategyType;
  baseCalculation: CalculationBasedType;
  currencyCode: string;
  targetRole: CampaignTargetUser;

  public onProductListFinished: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  public onGetProductFinished: Subject<any> = new Subject<any>();
  public onSchemeListChanged: Subject<any> = new Subject<any>();
  public onStepListChanged: Subject<any> = new Subject<any>();
  public captureToolTypeChanged: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private allowedValidationTools:ConsumptionValidationToolEnum[]=[
    ConsumptionValidationToolEnum.SecretCode,
    ConsumptionValidationToolEnum.OCR,
    ConsumptionValidationToolEnum.FiscalQR,
    ConsumptionValidationToolEnum.UniqueQR,
    ConsumptionValidationToolEnum.GLOIntegration,
    ConsumptionValidationToolEnum.External,
    ConsumptionValidationToolEnum.AdvertiserCampaign,
    ConsumptionValidationToolEnum.HandshakeQR
];
  constructor() {
    this.resetData();
  }

  resetData() {
    this.setSchemeList();
  }

  setStepList(steps?: PunchCardStep[], flowIndex?: number, previousFlow?: PunchCardStep){
    this.stepList = steps || [];
    this.onStepListChanged.next({stepList: this.stepList, step: previousFlow, index: flowIndex});
  }

  setSchemeList(schemes?: PunchCardSchema[]) {
    this.schemList = schemes || [];
    this.onSchemeListChanged.next(this.schemList);
  }

  isLinkedScheme(scheme: PunchCardSchema){
    return !!this.stepList?.find(item=>item.schemaId === scheme.id);
  }

  async getAdvertiser() {
    this.advertiser = await lastValueFrom(this.advertiserApi.getAdvertiserById(this.advertiserId));
  }

  async getProductList() {
    const res = await lastValueFrom(this.campaignsProductClient.getProducts(
              this.allowedValidationTools, FilterValidationToolOperatorEnum.Contains));
    this.productList = res;
  }

  async getProductListWithFilter(cvts: ConsumptionValidationToolEnum[]) {
    const res = await lastValueFrom(this.campaignsProductClient.getProducts(
              cvts, FilterValidationToolOperatorEnum.Contains));
    this.productList = res;
  }

  async getProductRewards() {
    if(!this.targetRole)
      return;

    this.isLoading = true;

    try {
      const isStaff = this.targetRole === CampaignTargetUser.Staff;
      const productInfos = await firstValueFrom(this.rewardProductsApi.getProductsByAdvertiserId(this.advertiserId, isStaff, false));

      this.rewardProductsOptions = productInfos.map((pi: ProductInfo) =>
        new ProductReward({
          productSlug: pi.slug,
          rewardTitle: pi.name,
          rewardDescription: pi.description,
          rewardThumbUrl: pi.photoUrl,
          rewardPhotoUrl: pi.photoUrl
        }));
    } finally {
      this.onGetProductFinished.next(true);
      this.isLoading = false;
    }
  }
}
